import StoreProduct from "../../component/store/store product/Store_Product";
import { useParams } from "react-router-dom";
import MStoreProduct from "../../component/mobile/store/store product/MStoreProduct";

const StoreProducts = () => {
  const { id } = useParams();

  return (
    <div className="STORE">
      {window.innerWidth<1000 && <MStoreProduct ID={id} />}
      {window.innerWidth>1000 && <StoreProduct ID={id} />}
    </div>
  );
};

export default StoreProducts;
